import getConfig from 'next/config';

export const getButtonLabel = (
  mode: 'create' | 'update',
  isProjectModified: boolean,
  projectReviewStatus: string | undefined,
  i18n: Record<string, string>
  
) => {
  let buttonLabel = '';
  if (mode === 'update') {
    buttonLabel = i18n['Save & Close'];
  } else {
    if (isProjectModified) {
      buttonLabel = i18n['Save & Close'];
    } else {
      buttonLabel = i18n['Cancel'];
    }
  }
  return buttonLabel;
};

export const isLowResolutionImageUploaded = (data: any) => {
  const { publicRuntimeConfig } = getConfig();
  const minimumRequiredDPI = publicRuntimeConfig.MINIMUM_DPI_LIMIT;
  let isLowResolutionImagePresent = false;
  for (let page of data.pages) {
    const dpiMultiplier =
      minimumRequiredDPI / (page.dimensions.unit_type_id === 'in' ? 1 : 25.4);

    for (let elementKey in page.elements) {
      const object = page.elements[elementKey];
      console.log(
        'Calculation',
        object.width * dpiMultiplier,
        object.source_width
      );

      if (object.type === 'image' && !object.template_element) {
        if (object.width * dpiMultiplier > object.source_width) {
          isLowResolutionImagePresent = true;
        } else {
          isLowResolutionImagePresent = false;
        }
      }
    }
  }
  return isLowResolutionImagePresent;
};

export const isAllProjectPagesModified = (
  originalPages: any[],
  modifiedPages: any[]
) => {
  if (originalPages.length === 0 || modifiedPages.length === 0) {
    return false;
  }
  for (let i = 0; i < originalPages.length; i++) {
    if (
      !isAllRequiredElementsFilled(
        originalPages[i].elements,
        modifiedPages[i].elements
      )
    ) {
      return false;
    }
  }
  return true;
};

const isAllRequiredElementsFilled = (
  originalPageElement: any,
  modifiedPageElements: any
) => {
  let orignalRequiredPageElements: any = {};
  let modifiedRequiredPageElements: any = {};

  const orignalRequiredPageElementKeys: any[] = [];
  Object.keys(originalPageElement).forEach((key: any) => {
    const element: any = originalPageElement[key];

    if (element.element_classes.includes('required')) {
      orignalRequiredPageElements[element.element_id] = element;
      orignalRequiredPageElementKeys.push(element.element_id);
    }
  });

  modifiedRequiredPageElements = Object.fromEntries(
    Object.entries(modifiedPageElements).filter(([key]) =>
      orignalRequiredPageElementKeys.includes(key)
    )
  );

  for (let i = 0; i < orignalRequiredPageElementKeys.length; i++) {
    const key = orignalRequiredPageElementKeys[i];
    switch (orignalRequiredPageElements[key].type) {
      case 'text':
        if (
          orignalRequiredPageElements[key].text ===
          modifiedRequiredPageElements[key].text
        ) {
          return false;
        }
        break;
      case 'zone':
        if (
          orignalRequiredPageElements[key].type ===
          modifiedRequiredPageElements[key].type
        ) {
          return false;
        }
        break;
    }
  }

  return true;
};

export const highlightRequiredElements = (editor: any, projectPage: any) => {
  console.log('projectPage', projectPage);
  const elementsObj = projectPage?.elements || {};
  const requiredElements: string[] = [];

  Object.keys(elementsObj).forEach((key: any) => {
    const element: any = elementsObj[key];

    if (element.element_classes.includes('required')) {
      requiredElements.push(element.element_id);
    }
  });

  console.log('requiredElements', requiredElements);

  editor.highlightElements(requiredElements, {
    duration: 30000,
    fill_color: '#8fd206',
    stroke_color: '#ffffff',
    starting_opacity: 0.65,
  });
};
